import React, {Component, ReactNode} from 'react';
import styled from 'styled-components';

import {HandlerOf, Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface WelcomeCarouselDropdownProps<T> {
  placeholder: ReactNode;
  items: ReadonlyArray<WelcomeCarouselDropdownItem<T>>;
  selectedItemKey?: T;
  onSelect: HandlerOf<WelcomeCarouselDropdownItem<T>>;
  renderDescription: Renderer;
}

export interface WelcomeCarouselDropdownItem<T> {
  key: T;
  title: ReactNode;
}

/*
 * Style.
 */

const StyledDropdownTitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.small};
  opacity: 1;
  grid-area: title;
  margin-bottom: -4px;
`;

/*
 * Component.
 */

export class WelcomeCarouselDropdown<T> extends Component<WelcomeCarouselDropdownProps<T>> {
  constructor(props: WelcomeCarouselDropdownProps<T>) {
    super(props);
  }

  /*
   * Event handlers.
   */

  private readonly onSelect = (item: WelcomeCarouselDropdownItem<T>) => {
    this.props.onSelect(item);
  };

  /*
   * Render.
   */

  render() {
    const {placeholder, selectedItemKey, items} = this.props;

    const itemForSelectedKey = items.find((i) => i.key === selectedItemKey);
    const value = itemForSelectedKey ? itemForSelectedKey.title : placeholder;

    return (
      <div>
        <StyledDropdownTitleDiv>{this.props.renderDescription()}</StyledDropdownTitleDiv>
        <DropdownBoxCoordinator
          value={value}
          size={VisualSizesEnum.MEDIUM}
          renderDropdown={(modalProps) => this.renderDropdown(modalProps)}
        />
      </div>
    );
  }

  private renderDropdown(modalProps: PopoverTransferProps) {
    const {items} = this.props;

    return (
      <SimpleDropdown {...modalProps}>
        {items.map((i) => (
          <SimpleDropdownItem key={String(i.key)} onSelect={() => this.onSelect(i)}>
            {i.title}
          </SimpleDropdownItem>
        ))}
      </SimpleDropdown>
    );
  }
}
